<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<script>
//  (function (win, doc) {
//         function change() {
//             document.documentElement.style.fontSize = 100 * document.documentElement.clientWidth / 750 + 'px';
//         }

//         doc.addEventListener('DOMContentLoaded', change, false);
//         doc.addEventListener('load', change, false);
//         win.addEventListener('resize', change, false);
//     })(window, document);

(function () {
      // 在标准 750px 适配下，100px = 1rem;
      var baseFontSize = 100;  
      var baseWidth = 750;
 
      var set = function () {
        var clientWidth = document.documentElement.clientWidth || window.innerWidth;
 
        var rem = 100;
        if (clientWidth != baseWidth) {
          rem = Math.floor(clientWidth / baseWidth * baseFontSize);
        }
 
        document.querySelector('html').style.fontSize = rem + 'px';
      }
      set();
 
      window.addEventListener('resize', set);
    }());
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/App.vue